/**
 * Created by n.rusev on 13/3/2019.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Row component nests Cols, so some children are expected."
    }
];

export default documentedProperties;
